import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';

export interface BreadCrumb {
  label: string;
  link?: string;
  // same type as @angular/router/RouterLinkWithHref.queryParams
  // note: could be outdated at anytime
  queryParams?: { [key: string]: any };
}

@Component({
  selector: 'sales-ui-nav-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreadcrumbsComponent implements OnChanges {
  @Input() breadCrumbs: BreadCrumb[];

  constructor(private readonly titleService: Title) {}

  ngOnChanges(changes: SimpleChanges): void {
    const crumbs: BreadCrumb[] = changes.breadCrumbs.currentValue;
    if (crumbs !== null) {
      this.titleService.setTitle(crumbs[crumbs.length - 1].label);
    }
  }
}
